import domready from "domready";
import Flatpickr from "flatpickr";
import "flatpickr/dist/l10n/de";

domready(function () {
  var quicksearch = document.getElementsByClassName("quicksearch");
  if (quicksearch !== null) {
    Array.prototype.forEach.call(quicksearch, function (qs) {
      var from = qs.querySelector(".quicksearch__field--date-from.flatpickr-input");
      var fromPreview = qs.querySelector(".quicksearch__field--date-from.form-control");
      var until = qs.querySelector(".quicksearch__field--date-until.flatpickr-input");
      var untilPreview = qs.querySelector(".quicksearch__field--date-until.form-control");
      function setValues(element) {
        var value = element.value;
        if (value.length > 10) {
          var matches = value.split(/(^.{10})( bis | to )(.{10}$)/g).filter(Boolean);
          from.value = matches[0];
          fromPreview.value = matches[0];
          until.value = matches[2];
          untilPreview.value = matches[2];
        }
      }
      if (from) {
        from.addEventListener("change", function () {
          setValues(from);
        });
      }
      if (until) {
        until.addEventListener("change", function () {
          setValues(until);
        });
      }
    });
  }
});
